// ommited useComparatorRef
// https://github.com/CSFrequency/react-firebase-hooks/blob/master/util/refHooks.ts
import { Query } from 'firebase/firestore'
import * as React from 'react'
import { queryEqual } from '~providers/firebase'

const { useEffect, useRef } = React

type RefHook<T> = {
  current: T
}

const isEqual = <A extends Query, B extends Query>(
  v1: A | null | undefined,
  v2: B | null | undefined,
): boolean => {
  const bothNull: boolean = !v1 && !v2
  const equal: boolean = !!v1 && !!v2 && queryEqual(v1, v2)
  return bothNull || equal
}

const useIsEqualRef = <T extends Query>(
  value: T | null | undefined,
  onChange?: () => void,
): RefHook<Query | null | undefined> => {
  const ref = useRef(value)
  useEffect(() => {
    if (!isEqual(value, ref.current)) {
      ref.current = value
      if (onChange) {
        onChange()
      }
    }
  })
  return ref
}

export default useIsEqualRef
